import { render, staticRenderFns } from "./AffiliateSignUp.vue?vue&type=template&id=96c0e7b8&scoped=true"
import script from "./AffiliateSignUp.vue?vue&type=script&lang=ts&setup=true"
export * from "./AffiliateSignUp.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./AffiliateSignUp.vue?vue&type=style&index=0&id=96c0e7b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96c0e7b8",
  null
  
)

export default component.exports